var BREAKPOINT_XS = "xs";
var BREAKPOINT_SM = "sm";
var BREAKPOINT_MD = "md";
var BREAKPOINT_LG = "lg";
var BREAKPOINT_XL = "xl";
var BUTTON_TYPES = {
  "Primary": {
    variant: "contained",
    color: "primary"
  },
  "Secondary": {
    variant: "contained",
    color: "secondary"
  },
  "Outlined": {
    variant: "outlined",
    color: "primary"
  },
  "Text": {
    variant: "text",
    color: "primary"
  }
};
var ONETRUST_COOKIES_CATEGORIES = {
  STRICTLY_NECESSARY: "C0001",
  PERFORMANCE: "C0002",
  FUNCTIONAL: "C0003",
  TARGETING: "C0004"
};

export { BREAKPOINT_LG, BREAKPOINT_MD, BREAKPOINT_SM, BREAKPOINT_XL, BREAKPOINT_XS, BUTTON_TYPES, ONETRUST_COOKIES_CATEGORIES };
//# sourceMappingURL=constant.js.map
